export default {
  brand: 'Sun Power',
  studio: 'Studio',
  lottery: 'Lucky Draw',
  companyHome: 'Company',
  companyHomeNotConfigured: 'Company website is not configured',
  game: 'Games',
  profile: 'Profile',
  service: 'Support',
  serviceNotConfigured: 'Support link not configured',
  language: 'Language',
  login: 'Login',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  inviteCode: 'UID',
  uid: 'UID',
  shareLink: 'Share link',
  copyLink: 'Copy link',
  copied: 'Copied',
  copyFail: 'Copy failed',
  recharge: 'Recharge',
  withdraw: 'Withdraw',
  exchange: 'Exchange',
  balanceUsd: 'USD Balance',
  balanceKwh: 'Reserve kWh',
  checkin: 'Check-in',
  upgrade: 'Level Up',
  team: 'My Team',
  basic: 'Basic',
  vip1: 'VIP1',
  vip2: 'VIP2',
  vip3: 'VIP3',
  activity: 'Activity',
  unitPrice: 'Unit price',
  quantity: 'Quantity',
  minQtyTip: 'Minimum order: {n}',
  expectKwh: 'Expected energy',
  totalAmount: 'Total amount',
  progress: 'Progress',
  buy: 'Buy',
  buyConfirm: 'Confirm purchase',
  confirmBuy: 'Pay now',
  buyConfirmTip: 'USD will be deducted from your balance. This cannot be undone.',
  buySuccess: 'Purchase successful',
  productName: 'Product',
  amount: 'Amount',
  rechargeRate: 'Exchange rate',
  rechargeActual: 'You will receive',
  enterAmount: 'Enter amount',
  network: 'Network',
  selectNetwork: 'Select network',
  withdrawAddress: 'Wallet address',
  enterWithdrawAddress: 'Enter wallet address',
  txHash: 'Tx hash',
  txHashOptional: 'Optional after transfer',
  copyAddress: 'Copy address',
  rechargeHint: 'Send USDT to the address below; your balance will be credited shortly after submit',
  withdrawHint: 'Balance is held on submit; fee is deducted, then sent to your wallet after approval',
  withdrawFeeRate: 'Fee rate',
  withdrawFee: 'Fee',
  withdrawReceive: 'You receive',
  withdrawTooLow: 'Amount too low after fee',
  rechargeSubmitted: 'Recharge submitted',
  withdrawSubmitted: 'Withdraw submitted',
  noQr: 'No QR code',
  noRechargeAddress: 'Deposit address not configured',
  rechargeProof: 'Payment proof',
  rechargeProofTip: 'Please upload a screenshot of the successful transfer',
  rechargeProofRequired: 'Please upload payment proof',
  confirm: 'Confirm',
  cancel: 'Cancel',
  kyc: 'KYC',
  realName: 'Real name',
  idCard: 'ID number',
  contact: 'Contact',
  contactPlaceholder: 'Phone / WhatsApp / Telegram',
  contactRequired: 'Contact is required',
  idFront: 'ID front',
  idBack: 'ID back',
  kycStatus: 'KYC status',
  kycNone: 'Not verified',
  kycPending: 'Processing',
  kycApproved: 'Verified',
  kycRejected: 'Not approved',
  kycTip: 'Enter your details and upload both sides of your ID',
  kycRequired: 'Name and ID are required',
  kycNeedPhotos: 'Please upload ID photos',
  kycSubmitted: 'Submitted, please wait',
  submit: 'Submit',
  logout: 'Logout',
  appDownload: 'Download App',
  downloadPickTip: 'Choose your phone system, then follow the install guide',
  downloadAndroidShort: 'APK package (Android)',
  downloadIosShort: 'Configuration profile (iPhone / iPad)',
  downloadNow: 'Download now',
  downloadAndroidSteps: [
    'Tap the button below to download the APK',
    'Open Files / Downloads, find the Sun Power package and open it',
    'If Google Play Protect says the app is blocked: tap “Install anyway”',
    'If unknown sources are blocked: Settings → Apps → Special app access → Install unknown apps, allow your browser or file manager',
    'Follow on-screen steps to finish install, then open Sun Power'
  ],
  downloadIosSteps: [
    'Tap the button below; Safari will open the install profile',
    'If you see “Profile Downloaded”: open Settings → Profile Downloaded (or General → VPN & Device Management)',
    'Tap Install, enter your passcode, then confirm',
    'After install, open Sun Power from the Home Screen',
    'If it won’t open: Settings → General → VPN & Device Management → select the profile → Trust'
  ],
  downloadAndroidNote: 'This app is downloaded from our website, not Google Play. Play Protect warnings are normal — choose “Install anyway”.',
  downloadIosNote: 'Please use Safari to install. Other browsers may not install the profile correctly.',
  downloadStarting: 'Preparing download…',
  downloadStarted: 'Download started. Check your browser or notifications',
  downloadIosStarted: 'Opening the install profile. Follow the on-screen steps',
  downloadFail: 'Download failed. Please try again',
  downloadUnavailable: 'App package unavailable. Please contact support',
  legalLicense: 'Legal License',
  businessReward: 'Business & Rewards',
  companyNews: 'Company News',
  newsEmpty: 'No news yet',
  newsAttachment: 'View attachment',
  loading: 'Loading…',
  attachmentLoadFail: 'Failed to load attachment. Please try again.',
  vipLevelNotify: 'VIP Level Notice',
  vipLevelChanged: 'Your VIP level changed from {from} to {to}',
  gotIt: 'Got it',
  loginNotice: 'Notice',
  roulette: 'Russian Roulette',
  prizes: 'Prizes',
  lotteryRules: 'Lottery Rules',
  draw: 'Draw',
  lotteryTimes: 'Draw chances',
  lotteryWin: 'You won',
  lotteryThanks: 'Thanks for playing',
  lotteryThanksShort: 'Thanks',
  lotteryThanksTip: 'No prize this time — try again next draw',
  lotteryRewardTip: '{reward} has been credited to your account',
  lotteryTimesReward: 'You got {n} more draw(s)',
  lotteryNoChance: 'No draw chances left',
  catchSun: 'Catch Sunlight',
  startGame: 'Start',
  score: 'Score',
  timeLeft: 'Time left',
  gameOver: 'Game over',
  reward: 'Reward',
  timesLeft: 'Plays left',
  gameNoChance: 'No plays left today',
  announcement: 'Announcement',
  noData: 'No data',
  loginTip: 'Sign in with email',
  registerTip: 'Enter UID to register',
  emailPlaceholder: 'Enter your email',
  passwordPlaceholder: 'Enter your password',
  confirmPassword: 'Confirm password',
  confirmPasswordPlaceholder: 'Re-enter password',
  invitePlaceholder: 'Enter UID',
  emailRequired: 'Email is required',
  passwordRequired: 'Password is required',
  passwordMin: 'At least 6 characters',
  confirmPasswordRequired: 'Please confirm password',
  passwordMismatch: 'Passwords do not match',
  inviteRequired: 'UID is required',
  noAccount: 'No account yet?',
  hasAccount: 'Already registered?',
  registerSuccess: 'Registered successfully',
  show: 'Show',
  hide: 'Hide',
  back: 'Back',
  level: 'Level',
  checkinDays: 'Streak days',
  checkinTip: 'Check in {days} days in a row for 1 lottery chance',
  doCheckin: 'Check in now',
  alreadyCheckin: 'Already checked in today',
  checkinSuccess: 'Check-in successful',
  checkinLottery: 'Check-in done, +1 lottery chance',
  upgradeTip: 'VIP1 requires all conditions below',
  kycDone: 'KYC done',
  firstRecharge: 'First recharge',
  inviteKyc: 'Invites KYC',
  inviteRecharge: 'Invite recharge',
  teamCount: 'Direct invites',
  teamL1: 'Level 1',
  teamL2: 'Level 2',
  teamL3: 'Level 3',
  teamAll: 'All',
  teamInviter: 'Invited by',
  teamInviterNone: 'No upline (registered without a member invite)',
  teamDownline: 'My invites',
  teamUpL1: 'Upline L1',
  teamUpL2: 'Upline L2',
  teamUpL3: 'Upline L3',
  teamUpRel1: 'Who invited you directly',
  teamUpRel2: 'Who invited your upline',
  teamUpRel3: 'Upline two levels above',
  teamParentSelf: 'Direct invite (invited by you)',
  teamParentL1: 'Level-1 referrer',
  teamParentL2: 'Level-2 referrer',
  teamRefByL1: 'Invited by L1 {email}',
  teamRefByL2: 'Invited by L2 {email}',
  teamRefL1: 'Under L1 {email}',
  logs: 'Account logs',
  myOrders: 'My Orders',
  dailyRebate: 'Daily Rebate',
  rebateToday: 'Today',
  rebateTotal: 'Total',
  rebateTip: 'Daily rebate = current kWh balance × rate: deduct kWh and credit USD. Buying products increases kWh to earn more daily USD.',
  totalKwh: 'Total kWh',
  pendingKwh: 'Pending',
  releasedKwh: 'Released',
  orderStatus: {
    '0': 'Active',
    '1': 'Completed',
    '2': 'Closed'
  },
  exchangeTip: 'Convert stored kWh to USD balance',
  exchangeAvailable: 'Available',
  exchangeRate: 'Rate',
  exchangeFee: 'Fee',
  exchangeAmountKwh: 'Amount (kWh)',
  exchangeAll: 'All',
  exchangeReceive: 'You receive',
  exchangeExceed: 'Exceeds available kWh',
  exchangeNoKwh: 'No kWh to exchange',
  success: 'Success',
  playing: 'Playing',
  tapSun: 'Tap falling sunlight to score',
  accountType: {
    USD: 'USD',
    KWH: 'kWh'
  },
  logType: {
    RECHARGE: 'Recharge',
    WITHDRAW: 'Withdraw',
    WITHDRAW_REFUND: 'Withdraw refund',
    EXCHANGE: 'Exchange',
    GAME: 'Game reward',
    LOTTERY: 'Lottery',
    INVITE_KYC: 'Invite KYC reward',
    BUY_PRODUCT: 'Buy product',
    REBATE_Ln: 'L{n} rebate',
    REBATE_L1: 'L1 rebate',
    REBATE_L2: 'L2 rebate',
    REBATE_L3: 'L3 rebate',
    DAILY_REBATE: 'Daily rebate',
    MANAGE_REWARD: 'Management reward',
    ADMIN_ADJUST: 'Admin adjust'
  }
}
